var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chat/Bubble Multiple",
    clipPath: "url(#clip0_1747_10449)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85715 1.14286C2.7056 1.14286 2.56026 1.20306 2.45309 1.31022C2.34593 1.41739 2.28573 1.56273 2.28573 1.71429V8.57143C2.28573 8.63285 2.27582 8.69386 2.2564 8.75213L1.44395 11.1895L2.1454 11.0118C2.45132 10.9343 2.76215 11.1195 2.83966 11.4254C2.91716 11.7313 2.73198 12.0421 2.42606 12.1196L0.711769 12.5539C0.509284 12.6052 0.294944 12.542 0.15278 12.3889C0.0106151 12.2359 -0.0367184 12.0175 0.0293358 11.8193L1.14287 8.4787V1.71429C1.14287 1.25963 1.32348 0.823594 1.64497 0.502103C1.96646 0.180612 2.4025 0 2.85715 0H12C12.4547 0 12.8907 0.180612 13.2122 0.502103C13.5337 0.823593 13.7143 1.25963 13.7143 1.71429V3.42857C13.7143 3.74416 13.4585 4 13.1429 4C12.8273 4 12.5714 3.74416 12.5714 3.42857V1.71429C12.5714 1.56273 12.5112 1.41739 12.4041 1.31022C12.2969 1.20306 12.1516 1.14286 12 1.14286H2.85715Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07354 6.21639C5.39503 5.8949 5.83107 5.71429 6.28573 5.71429H13.7143C14.169 5.71429 14.605 5.8949 14.9265 6.21639C15.248 6.53788 15.4286 6.97391 15.4286 7.42857V11.9527L15.9922 15.3346C16.0245 15.528 15.9554 15.7243 15.8091 15.8548C15.6629 15.9854 15.4601 16.0319 15.2716 15.978L11.3486 14.8571H6.28573C5.83107 14.8571 5.39503 14.6765 5.07354 14.355C4.75205 14.0335 4.57144 13.5975 4.57144 13.1429V7.42857C4.57144 6.97391 4.75205 6.53788 5.07354 6.21639ZM6.28573 6.85714C6.13417 6.85714 5.98883 6.91735 5.88167 7.02451C5.7745 7.13167 5.7143 7.27702 5.7143 7.42857V13.1429C5.7143 13.2944 5.7745 13.4398 5.88167 13.5469C5.98883 13.6541 6.13417 13.7143 6.28573 13.7143H11.4286C11.4817 13.7143 11.5345 13.7217 11.5856 13.7363L14.7163 14.6308L14.2935 12.0939C14.2883 12.0629 14.2857 12.0315 14.2857 12V7.42857C14.2857 7.27702 14.2255 7.13167 14.1184 7.02451C14.0112 6.91735 13.8658 6.85714 13.7143 6.85714H6.28573Z",
    fill: "currentColor"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1747_10449"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chat-bubble.fe6ca5de7a7b8e8b4aab63b90b131a22.svg";
export { ForwardRef as ReactComponent };